/**
 * ── INTERNATIONAL POSTAGE, KEPT EQUAL TO THE CARDS GOING ABROAD ─────────
 *
 * decisions.md 2026-09-15 (night): postage is a cart LINE, not a shipping
 * rate. Each card whose `_Country` is not US owes one unit of the product
 * "International postage" (window.PP_POSTAGE_VARIANT, set by
 * snippets/pp-address-config.liquid). Daniel: "that way we can play around
 * with the shipping rates in the future as well" — so the price lives on the
 * product, and nothing here knows what it is.
 *
 * ⭐ ONE RECONCILIATION, NOT BOOKKEEPING. Every place that changes the cart
 * (the builder's add, the cart editor's save and copy, a plain Remove) would
 * otherwise have to add or subtract postage itself, and one of them would
 * forget. Instead each calls sync(), which reads the cart and sets postage to
 * exactly the number it should be. Running it twice is harmless.
 *
 * ⛔ THE POSTAGE LINE CARRIES NO PROPERTIES. The print queue treats any line
 * with properties as a card (fulfilment/worker.js, cardLines), so a key on
 * this line would put an empty card in a batch. It also means Shopify merges
 * every unit into one line, which is what lets /cart/update.js set it by
 * variant id.
 *
 * The checkout Function (card-complete) refuses a checkout where the two
 * counts disagree, so a failure here costs a refused checkout that says why —
 * never a card posted abroad unpaid.
 */
(function () {
  'use strict';

  var VARIANT = Number(window.PP_POSTAGE_VARIANT || 0);

  function isPostage(it) { return !!VARIANT && Number(it.variant_id) === VARIANT; }

  function abroad(it) {
    var c = String((it.properties && it.properties['_Country']) || '').trim().toUpperCase();
    return !!c && c !== 'US';
  }

  /* ⭐ FREE POSTAGE ON 3 CARDS OR MORE (Daniel, 2026-09-15: "3 cards gives you
     free shipping" — any 3 cards in the order, US or abroad). A count, not a
     money value, because cards are the only product. The same 3 is in the
     checkout Function (card-complete, FREE_POSTAGE_CARDS) and must move with
     it. Set in snippets/pp-address-config.liquid. */
  var FREE_AT = Number(window.PP_FREE_POSTAGE_CARDS || 3);

  // A card is a line that carries a photo, or a Christmas card's pp-xmas job: the checkout Function's own proof.
  function isCard(it) {
    var p = it.properties || {};
    return !isPostage(it) && (!!String(p['_Photo 1'] || p['Photo 1'] || '').trim() ||
      (p['_Card Kind'] === 'xmas' && /^cx-[0-9a-f]{20}$/.test(String(p['_Xmas Job'] || ''))));
  }

  /** Postage units the cart OWES: one per international card, through quantity —
   *  and none at all once the order holds FREE_AT cards. */
  function owed(cart) {
    var items = cart.items || [];
    var cards = items.reduce(function (n, it) {
      return isCard(it) ? n + (Number(it.quantity) || 0) : n;
    }, 0);
    if (cards >= FREE_AT) return 0;
    return items.reduce(function (n, it) {
      return !isPostage(it) && abroad(it) ? n + (Number(it.quantity) || 0) : n;
    }, 0);
  }

  /** Postage units the cart HOLDS. */
  function held(cart) {
    return (cart.items || []).reduce(function (n, it) {
      return isPostage(it) ? n + (Number(it.quantity) || 0) : n;
    }, 0);
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('postage_' + url + '_' + res.status);
      return true;
    });
  }

  /**
   * Make the cart's postage equal what it owes.
   * @returns Promise<boolean> — true when the cart was changed, so a caller
   *          that renders the cart knows to reload it.
   */
  function sync() {
    if (!VARIANT) return Promise.resolve(false);
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var want = owed(cart), have = held(cart);
        if (want === have) return false;
        if (have === 0) return post('/cart/add.js', { items: [{ id: VARIANT, quantity: want }] });
        var updates = {};
        updates[VARIANT] = want;          // 0 removes the line
        return post('/cart/update.js', { updates: updates });
      });
  }

  window.PPPostage = { sync: sync, variant: VARIANT, isPostageVariant: function (id) {
    return !!VARIANT && Number(id) === VARIANT;
  } };
})();
